/**
 * Builds the service worker script URL carrying our backend base URLs as
 * repeated `api` query params. `custom-sw.js` reads them from
 * `self.location.search`, so it only remaps network failures for requests to
 * our own backend, whether the base URL came from the build environment or
 * from `assets/runtime-config.js`.
 */
export function buildSwScriptUrl(
  script: string,
  backendBaseUrls: readonly (string | undefined)[]
): string {
  const params = new URLSearchParams();

  for (const url of new Set(backendBaseUrls)) {
    if (url) {
      params.append('api', url);
    }
  }

  const query = params.toString();

  return query ? `${script}?${query}` : script;
}
